export default __webpack_public_path__ + "static/adorno-4ef25e4e7af61610d1a03405af3d635e.png";